$(function(){
	var slider = document.getElementById('slider');
	window.slider = Swipe(slider, {
        startSlide: 0,
        continuous: false,
        stopPropagation: true,
        callback: function(index, element) {
        	$(".page-data .point").removeClass("active");
        	$(".page-data .point").eq(index).addClass("active");
            var num=$(".page-data .point").size();
            if(index>=num-1){
                $(".page-data .points").hide();
            }else{
                $(".page-data .points").show();
            }
        }
    })
    var main={
    	el:$("body"),
        fisrtTouch:true,
    	init:function(){
    		var _this=this;
    		response.tycredidential=getArgs().tycredidential;
    		if(notAllEmpty()){
    			$(".page-home-hasdata").show();
    		}else{
    			$(".page-home-nodata").show();
    		}

    		$(".startBtn").click(function(){
    			$(".page-home-hasdata").hide();
    			$(".page-data").addClass("active");
    		})

    		var btns=$('<div class="btns"><a href="javascript:;" class="shareBtn"></a><a href="javascript:;" class="hbBtn"></a></div>');
    		$(".paper").last().append(btns);
    		if(response.has2016Gift>0){
    			$(".hbBtn").hide();
    		}else{
    			hongbao.init();
    		}
    		this.changePage2Text();
    		this.changePage3Text();
    		this.changePage4Text();

    		this.audio=this.el.find("#audio")[0];    		
    		$(".musicBtn").click(function(){
    			if($(this).hasClass("on")){
    				_this.audio.pause();
    				$(".musicBtn").removeClass("on");
    			}else{
    				_this.audio.play();
    				$(".musicBtn").addClass("on");
    			}
    		})

    		$(".shareBtn").click(function(){
                try{
                    CommonJSHelper.shareWithImageTitleDespUrl($("#share-image").val(),$("#share-title").val(),$("#share-introduction").val(),$("#share-url").val());
                }catch(e){
                    console.log("分享报错");
                }
    		})
    		
    		$("#share-url").val(window.location.protocol+"//"+window.location.hostname+":"+window.location.port+"/m/annualdata/share"+"?id="+response.playerId);
            this.addPoint(); 
            $(window).on("touchstart",function(){
                if(_this.fisrtTouch){
                    _this.audio.play();
                    _this.fisrtTouch=false;
                    $(".musicBtn").addClass("on");
                }
            })

            if(navigator.userAgent.indexOf("appversion")==-1){
                alert("请使用天谕APP参加活动");
                $(".hbBtn").hide();
                $(".startBtn").hide();
            }else{
                if(!response.logined){
                    autoReLogin();
                }
            }


    	},
    	changePage2Text:function(){
    		if(response.commentCount<100){
    			$(".paper-2 .bottomTxt").html("一砖一瓦总是情");
    		}
    		if(response.yukashowVoteCount>200||response.commentCount>=100){
    			$(".paper-2 .bottomTxt").html("谕咖social明灯，我来守护");
    		}
    		if(response.yukashowGetVoteCount>=1000){
    			$(".paper-2 .bottomTxt").html("social之星，舍我其谁");
    		}
    	},
    	changePage3Text:function(){
    		if(response.getappseduceCount>50){
    			$(".paper-3 .bottomTxt").html("万人迷，舍我其谁");
    		}else if(response.appseduceCount>=100){
    			$(".paper-3 .bottomTxt").html("撩人狂魔，非我莫属");
    		}else{
    			$(".paper-3 .bottomTxt").html("撩人征途，长路漫漫");
    		}
    	},
    	changePage4Text:function(){
    		if(response.signCount>=365){
    			$(".paper-4 .bottomTxt").html("劳模之星，非我莫属");
    		}else if(response.yupiaoCount>4000){
    			$(".paper-4 .bottomTxt").html("家财积累，唯勤奋也");    			
    		}else if(response.signCount>=200){
    			$(".paper-4 .bottomTxt").html("因为爱得深沉");  
    		}else{
    			$(".paper-4 .bottomTxt").html("潜力很大，鉴定完毕"); 
    		}
    	},
    	addPoint:function(){
    		$(".page-data .cnt").each(function(){
		        var span=$("<span class='point'></span>");
		        $(".page-data .points").append(span);
		    })
		    $(".page-data .points .point").eq(0).addClass("active");
		    $(".page-data .points .point").click(function(){
		    	var index = $(this).index();
		    	window.slider.slide(index,300);
		    })
    	}

    }
    var hongbao={
    	el:$(".m-hongbao"),
    	init:function(){
    		var _this=this;
    		$(".hbBtn").click(function(){
    			_this.show();
    		})
    		this.el.find(".openBtn").click(function(e){
    			if(response.has2016Gift>0){
    				// alert("已领过！");
    				return;
    			}
    			$.getJSON("/m/annualdata/getYear2016Gift.json?tycredidential="+response.tycredidential,function(msg){
    				if(msg.resCode==11){
    					autoReLogin();
    					return;
    				}
    				if(msg.resCode!=0){
    					alert(msg.resReason);
    					return;
    				}
    				_this.el.find(".hongbao").addClass("active");
    				response.has2016Gift=99;
    				$(".hbBtn").hide();
    			})
    			
    		})
    		this.el.find(".closeBtn").click(function(){
    			_this.el.hide();
    		})
    	},
    	show:function(){
    		this.el.show();
    	}
    }
    main.init();
})

function notAllEmpty(){
	return response.yukashowCount||response.shareCount||response.yukashowVoteCount||response.yukashowGetVoteCount||response.commentCount||response.messageboardCount||response.appseduceCount||response.getappseduceCount||response.signCount||response.yupiaoCount||response.duihuanCount||response.response
}

function autoReLogin(){
  	if(typeof(CommonJSHelper)!="undefined"){
    	try{
      		CommonJSHelper.tyInvalid();
    	}catch(e){
      		alert("请登录");
    	}
  	} else {
    	alert("请登录");
  	}
}
/* 获取URL 信息 */
function getArgs() {
    var args = {}; //声明一个空对象
    var query = window.location.search.substring(1); // 取查询字符串，如从 http://www.snowpeak.org/testjs.htm?a1=v1&a2=&a3=v3#anchor 中截出 a1=v1&a2=&a3=v3。
    var pairs = query.split("&"); // 以 & 符分开成数组
    for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf('='); // 查找 "name=value" 对
        if (pos == -1) continue; // 若不成对，则跳出循环继续下一对
        var argname = pairs[i].substring(0, pos); // 取参数名
        var value = pairs[i].substring(pos + 1); // 取参数值
        value = decodeURIComponent(value); // 若需要，则解码
        args[argname] = value; // 存成对象的一个属性
    }
    return args; // 返回此对象
}


//////////////////
// WEBPACK FOOTER
// ./pages/annualdata/js/index.js
// module id = 0
// module chunks = 0